<template>
  <the-content>
    <template v-if="client">
      <div class="heading">
        <div class="heading-nav">
          <v-btn :to="{name: 'clients.list'}" text fab small exact>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </div>
        <h1 class="heading-title">Карточка Клиента</h1>
      </div>

      <ValidationObserver ref="form" v-slot="{ passes, dirty }" tag="div" class="client-block">
        <v-card class="client-toolbar">
          <v-toolbar class="elevation-0" color="blue lighten-5">
            <div class="client-toolbar__item">
              <client-visits-history-dialog :clientId="client.id"/>
            </div>
            <div class="client-toolbar__item">
              <client-messages-show-dialog :clientId="client.id"/>
            </div>
            <div class="client-toolbar__item">
              <message-create-dialog v-if="client.viber_id || client.telegram_id" :to="client.id">
                <template v-slot:default="{on:dialog}">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on:tooltip }">
                      <v-btn color="blue"
                             dark
                             fab
                             small
                             depressed
                             v-on="{...dialog, ...tooltip}"
                      >
                        <v-icon>mdi-email-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Написать новое сообщение</span>
                  </v-tooltip>
                </template>
              </message-create-dialog>
            </div>
            <v-spacer></v-spacer>
            <div class="client-toolbar__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="success"
                         @click.prevent="save"
                         small
                         fab
                         depressed
                         v-on="on"
                         :disabled="!dirty && (!photo || editPhoto)"
                  >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Сохранить изменения</span>
              </v-tooltip>
            </div>
            <div class="client-toolbar__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="error"
                         dark
                         @click.prevent="remove"
                         small
                         fab
                         depressed
                         v-on="on"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Удалить карточку клиента</span>
              </v-tooltip>
            </div>
          </v-toolbar>
        </v-card>

        <v-chip-group column class="client-chips" dark>
          <v-chip v-if="client.viber_id" color="#8f5db7" disabled>Viber</v-chip>
          <v-chip v-if="client.telegram_id" color="#36ade1" disabled>Telegram</v-chip>
          <v-chip v-if="daysBeforeBday<=3 && daysBeforeBday !== 0" color="warning" disabled>
            <v-avatar left color="orange darken-4">
              <v-icon small>mdi-cake-variant</v-icon>
            </v-avatar>
            День рождения (через {{daysBeforeBday}} д.)
          </v-chip>

          <v-tooltip v-if="isLostClient(client)" bottom>
            <template v-slot:activator="{ on }">
              <v-chip color="warning" v-on="on">
                Потерянный клиент
              </v-chip>
            </template>
            <span>Неактивен с {{$dayjs.unix(client.active_until).format('DD MMMM YYYY')}}</span>
          </v-tooltip>

          <v-chip v-if="daysBeforeBday === 0" color="green" disabled>
            <v-avatar left color="green darken-4">
              <v-icon small>mdi-cake-variant</v-icon>
            </v-avatar>
            Сегодня День рождения
          </v-chip>
        </v-chip-group>

        <v-card class="client-card">
          <v-card-text class="pa-6">

            <v-row>
              <v-col cols="12" sm="6" md="4" lg="4" class="client-photo-col">
                <!-- photo start -->
                <div class="client-photo">
                  <div class="client-photo-wrap">
                    <template v-if="client.photo && false === newPhoto">
                      <div class="client-photo-image"
                           :style="'background-image: url(' + client.photo.url + ');'"></div>
                      <div class="client-photo-actions">
                        <v-btn @click.prevent="addNewPhoto" color="primary" small fab
                               class="mx-4">
                          <v-icon>mdi-camera</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <template v-else-if="true === newPhoto">
                      <webcam-photo v-if="webcam" @input="setPhoto" @close="resetPhoto"/>
                      <edit-photo
                        v-else-if="editPhoto"
                        :src="originalPhoto"
                        @input="photo=$event"
                        @cancel="editPhoto=false"
                      />
                      <template v-else>
                        <div class="client-photo-image"
                             :style="{backgroundImage: photo ? `url(${photo})` : ''}"></div>
                        <div class="client-photo-actions">
                          <v-btn @click.prevent="editPhoto=true" color="primary" small fab
                                 class="mx-4">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn @click.prevent="resetPhoto" color="error" small fab
                                 class="mx-4">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <div class="client-photo-add" @click.prevent="addNewPhoto">
                        <v-icon>mdi-plus</v-icon>
                        Добавить фото
                      </div>
                    </template>
                  </div>
                </div>
                <!-- photo end -->
              </v-col>
              <v-col cols="12" sm="6" md="8" lg="8" class="pt-0">
                <!-- information start -->
                <div class="client-info">
                  <v-row>
                    <v-col cols="12" class="pb-0" md="6">
                      <ValidationProvider
                        name="name"
                        rules="required"
                        v-slot="{ errors }"
                        tag="div"
                        class="client-info-group"
                      >
                        <v-text-field
                          type="text"
                          v-model="name"
                          label="Ф.И.О."
                          :error-messages="errors"
                          required
                          outlined
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pb-0" md="6">
                      <ValidationProvider
                        name="phone"
                        rules="required"
                        v-slot="{ errors }"
                        tag="div"
                        class="client-info-group">
                        <div
                          class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--single-line v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
                          :class="{'error--text': errors.length, 'v-input--has-state': errors.length, 'v-input--is-focused primary--text': telFocused}"
                        >
                          <div class="v-input__control">
                            <div class="v-input__slot" @click.stop="telFocus">
                              <fieldset aria-hidden="true">
                                <legend style="width: 55px;"><span>&#8203;</span>
                                </legend>
                              </fieldset>
                              <div class="v-text-field__slot">
                                <label for="input-tel"
                                       :class="{'error--text': errors.length}"
                                       class="v-label v-label--active theme--light"
                                       style="left: 0; right: auto; position: absolute;">Телефон</label>
                                <vue-tel-input
                                  id="input-tel"
                                  v-model="phone"
                                  :dynamicPlaceholder="true"
                                  :enabledCountryCode="false"
                                  :disabledFormatting="true"
                                  :preferredCountries="['BY', 'RU']"
                                  defaultCountry="BY"
                                  :disabledFetchingCountry="true"
                                  :validCharactersOnly="true"
                                  :inputOptions="{showDialCode: false}"
                                  mode="international"
                                  autocomplete="off"
                                  required
                                />
                              </div>
                            </div>
                            <div class="v-text-field__details">
                              <div class="v-messages theme--light"
                                   :class="{'error--text': errors.length}">
                                <div class="v-messages__wrapper">
                                  <div class="v-messages__message"
                                       v-if="errors.length">{{
                                    errors[0] }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pb-0" md="6">
                      <ValidationProvider name="gender"
                                          v-slot="{ errors }"
                                          tag="div"
                                          class="client-info-group"
                      >
                        <v-select
                          :items="[{title: 'мужчина', value: $constants.GENDER_MALE}, {title:'женщина',value: $constants.GENDER_FEMALE}]"
                          v-model="gender"
                          item-text="title"
                          item-value="value"
                          label="Пол"
                          :error-messages="errors"
                          outlined
                          hint="Необязательно"
                          persistent-hint
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pb-0" md="6">
                      <ValidationProvider
                        name="bday"
                        v-slot="{ errors }"
                        tag="div"
                        class="client-info-group">
                        <v-menu
                          v-model="bdayPicker"
                          :close-on-content-click="false"
                          :nudge-right="33"
                          :nudge-top="25"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{on}">
                            <v-text-field
                              v-model="bdayFormatted"
                              @blur="bday = parseDate(bdayFormatted)"
                              label="Дата рождения ДД.ММ.ГГГГ"
                              v-mask="'##.##.####'"
                              clearable
                              v-on="on"
                              :error-messages="errors"
                              outlined
                              hint="Необязательно"
                              persistent-hint
                            />
                          </template>
                          <v-date-picker
                            ref="bdayPicker"
                            v-model="bday"
                            locale="ru-RU"
                            @input="onBdayPickerInput"
                            first-day-of-week="1"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          />
                        </v-menu>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <ValidationProvider
                        name="notes"
                        v-slot="{ errors }"
                        tag="div"
                        class="client-info-group">
                        <v-textarea
                          name="notes"
                          label="Заметки"
                          v-model="notes"
                          clearable
                          outlined
                          :error-messages="errors"
                          auto-grow
                          hint="Необязательно"
                          persistent-hint
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </div>
                <!-- information end -->
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </ValidationObserver>

      <div class="client-block">
        <div class="heading">
          <h2 class="heading-title">Абонементы:</h2>
          <div class="heading-buttons">
            <div class="heading-buttons__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on:tooltip }">
                  <v-btn
                    color="green"
                    dark
                    small
                    :fab="$vuetify.breakpoint.mdAndDown"
                    v-on="{...tooltip}"
                    @click.prevent="singleVisitDialogClientId=client.id"
                  >
                    <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-plus-one</v-icon>
                    <span class="d-none d-lg-block">Разовое посещение</span>
                  </v-btn>
                </template>
                <span>Отметить разовое посещение</span>
              </v-tooltip>
            </div>
            <div class="heading-buttons__item">
              <card-add-dialog :client="client" @saved="fetchClient"/>
            </div>
          </div>
        </div>
        <v-card class="ticket-tabs">
          <v-tabs v-model="tab" show-arrows centered background-color="transparent">
            <v-tab v-for="tab in tabs" :key="tab.name">
              <span>{{ tab.name }}</span>
              <v-chip :ripple="false" small dark color="blue lighten-2" class="ml-1">
                {{filterCardsByStatus(tab.status).length}}
              </v-chip>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" style="background-color: rgba(225, 245, 254, 0.3);">
            <v-tab-item v-for="tab in tabs" :key="tab.name">
              <v-data-iterator
                :items="filterCardsByStatus(tab.status)"
                :items-per-page="cardsItemsPerPage"
                :footer-props="cardsFooterProps"
              >
                <template v-slot:default="props">
                  <v-container class="px-6 py-3">
                    <v-row>
                      <v-col cols="12" sm="6" lg="4" xl="3"
                             v-for="(card) in props.items"
                             :key="card.id">
                        <v-card class="ticket-card">
                          <div class="card-toolbar px-1 py-2">
                            <v-spacer></v-spacer>
                            <card-visits-dialog
                              :card="card"
                              @visit-deleted="refreshClient();card.visits_count-=1"
                            />
                            <card-edit-dialog
                              :card="card"
                              @saved="fetchClient"
                            />
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  color="error"
                                  @click.prevent="deleteCard(card)"
                                  x-small fab
                                  class="mx-2"
                                  depressed
                                  v-on="on"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Удалить абонемент</span>
                            </v-tooltip>
                          </div>
                          <v-divider></v-divider>
                          <v-card-title class="pt-3 pb-4">{{card.type.name}}</v-card-title>
                          <v-card-text>
                            <ul>
                              <li><b>Создан:</b> {{
                                $dayjs.unix(card.created_at).format('DD.MM.YYYY в HH:mm') }}
                              </li>
                              <li><b>Активен:</b> с {{formatDate(card.start_at)}} по
                                {{formatDate(card.end_at)}}
                              </li>
                              <li><b>Посещений:</b> {{card.visits_count || 0}} из
                                {{card.visits_limit
                                ||
                                'безлимит'}}
                              </li>
                            </ul>
                          </v-card-text>
                          <template
                            v-if="card.status === 'active' && (!card.visits_limit || card.visits_count < card.visits_limit)">
                            <v-divider class="mt-auto"></v-divider>
                            <v-card-actions class="pa-4">
                              <v-btn dark
                                     depressed
                                     color="green"
                                     @click.prevent="trackVisit(card)"
                                     width="100%"
                              >
                                <v-icon left>mdi-check</v-icon>
                                Отметить посещение
                              </v-btn>
                            </v-card-actions>
                          </template>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <template v-slot:no-data>
                  <v-col cols="12">
                    <div class="tab-placeholder">Абонементы отсутствуют</div>
                  </v-col>
                </template>
              </v-data-iterator>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
      <single-visit-dialog
        v-model="singleVisitDialogClientId"
        @marked="fetchClient"
      />
      <card-expired-dialog v-model="showCardExpiredDialog"/>
    </template>
  </the-content>
</template>

<script>
  import clientApi from '../api/client.api';
  import cardApi from '../api/card.api';
  import visitApi from '../api/visit.api';
  import { VueTelInput } from 'vue-tel-input';
  import { isMobile } from '../helpers';
  import dayjs from 'dayjs';
  import { mask } from 'vue-the-mask';
  import ClientMessagesShowDialog from '../components/ClientMessagesShowDialog';
  import lostClientMixin from '../mixins/lostClientMixin';
  import ClientVisitsHistoryDialog from '../components/ClientVisitsHistoryDialog';
  import SingleVisitDialog from '../components/SingleVisitDialog';
  import cardExpiredNotificationMixin from '../mixins/cardExpiredNotificationMixin';
  import CardExpiredDialog from '../components/CardExpiredDialog';

  export default {
    name      : 'ClientShowPage',
    props     : {
      clientId: {
        required: true,
      }
    },
    components: {
      CardExpiredDialog,
      SingleVisitDialog,
      ClientVisitsHistoryDialog,
      ClientMessagesShowDialog,
      VueTelInput
    },
    directives: {
      mask,
    },
    mixins    : [lostClientMixin, cardExpiredNotificationMixin],
    data() {
      return {
        client: null,

        photo        : null,
        name         : '',
        phone        : '',
        gender       : '',
        bday         : '',
        notes        : '',
        originalPhoto: null,

        bdayFormatted: '',

        webcam   : false,
        editPhoto: false,
        newPhoto : false,

        bdayPicker: false,

        telFocused: false,

        tab : null,
        tabs: [
          { name: 'Активные', status: 'active' },
          { name: 'Неактивные', status: 'inactive' },
          { name: 'Истекшие', status: 'expired' },
        ],

        isMobilePlatform: isMobile(),

        singleVisitDialogClientId: null,
      };
    },
    computed  : {
      daysBeforeBday() {
        let days = null;

        if (this.client) {
          const today = dayjs().startOf('day');
          let bday    = dayjs(this.client.bday).startOf('day').year(today.year());
          days        = bday.diff(today, 'day');
          if (days < 0) {
            bday = bday.add(1, 'year');
            days = bday.diff(today, 'day');
          }
        }

        return days;
      },
      cardsItemsPerPage() {
        return this.$vuetify.breakpoint.mdAndDown ? 4 : 3;
      },
      cardsFooterProps() {
        return {
          itemsPerPageOptions: this.$vuetify.breakpoint.mdAndDown ? [4, 8, 12, -1] : [3, 6, 9, -1],
          showCurrentPage    : true,
          itemsPerPageText   : 'Абонементов на странице',
        };
      },
    },
    watch     : {
      bdayPicker(val) {
        val && setTimeout(() => (this.$refs.bdayPicker.activePicker = 'YEAR'));
      }
    },
    created() {
      this.fetchClient();
      window.addEventListener('click', this.telBlur);
    },
    methods   : {
      fetchClient() {
        this.client = null;

        this.$store.commit('setLoading', true);

        this.refreshClient().catch(() => {
          this.$router.push({ name: 'clients.list' });
        }).finally(() => {
          this.$store.commit('setLoading', false);
        });
      },
      refreshClient() {
        return clientApi.find(this.clientId).then(({ data }) => {
          const client = data.data;

          this.client        = client;
          this.name          = client.name;
          this.phone         = client.phone;
          this.bday          = client.bday;
          this.gender        = client.gender;
          this.notes         = client.notes;
          this.bdayFormatted = this.formatDate(this.bday);
        });
      },
      filterCardsByStatus(status) {
        return !this.client.cards ? [] : this.client.cards.filter((item) => {
          return item.status === status;
        });
      },
      async trackVisit(card) {
        const confirmed = await this.$confirm('Вы уверены что хотите отметить посещение?');

        if (false === confirmed) {
          return;
        }

        visitApi.create({ card_id: card.id }).then(({ data }) => {
          Object.assign(card, data.data);
          this.$store.dispatch('clients/refresh');
          this.$_notifyCartExpired(data.data);
        }).catch(() => {
          this.$toast.error('Произошла ошибка во время отметки посещения');
        });
      },
      save() {
        this.$store.commit('setLoading', true);

        this.$store.dispatch('clients/update', {
          id  : this.clientId,
          data: {
            name  : this.name,
            phone : this.phone,
            photo : this.photo,
            bday  : this.bday,
            gender: this.gender,
            notes : this.notes,
          }
        }).then(({ data }) => {
          this.client = Object.assign(this.client, data.data);
          this.resetPhoto();
          this.$refs.form.reset();
        }).catch(({ response }) => {
          this.$refs.form.setErrors(response.data.errors);
        }).finally(() => {
          this.$store.commit('setLoading', false);
        });
      },

      async deleteCard(card) {
        const confirmed = await this.$confirm('Вы уверены что хотите удалить этот абонемент?');

        if (false === confirmed) {
          return;
        }

        this.$store.commit('setLoading', true);

        cardApi.delete(card.id).then(() => {
          this.fetchClient();
          this.$store.dispatch('clients/refresh');
        }).catch(() => {
          this.$toast.error('Произошла ошибка во время удаления абонемента');
        }).finally(() => {
          this.$store.commit('setLoading', false);
        });
      },
      async remove() {
        const confirmed = await this.$confirm('Вы уверены что хотите удалить клиента из базы?');
        if (false === confirmed) {
          return;
        }

        this.$store.dispatch('clients/remove', this.client.id).then(() => {
          this.$router.push({ name: 'clients.list' });
        }).catch(() => {
          this.$toast.error('Произошла ошибка во время удаления клиента');
        });
      },

      addNewPhoto() {
        this.webcam   = true;
        this.newPhoto = true;
      },
      setPhoto(newPhoto) {
        this.webcam        = false;
        this.photo         = newPhoto;
        this.originalPhoto = newPhoto;
        this.editPhoto     = true;
      },
      resetPhoto() {
        this.photo         = null;
        this.originalPhoto = null;
        this.newPhoto      = false;
      },
      telFocus() {
        this.telFocused = true;
      },
      telBlur() {
        this.telFocused = false;
      },
      parseDate(date) {
        if (!date) return null;

        return dayjs(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
      },
      formatDate(date) {
        if (!date) return null;

        return dayjs(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
      },
      onBdayPickerInput() {
        this.bdayPicker    = false;
        this.bdayFormatted = this.formatDate(this.bday);
      },

    }
  };
</script>

<style lang="scss">

  .client-block {
    + .client-block {
      margin-top: 60px;
    }
  }


  .client-toolbar {

    .v-toolbar,
    .v-toolbar__content {
      height: auto !important;
    }

    .v-toolbar__content {
      flex-wrap: wrap;

      .viewport-xs & {
        padding-left: 8px;
        padding-right: 8px;
      }
    }

    .client-toolbar__item {
      margin: 8px;

      .viewport-xs & {
        margin: 4px 8px;
      }
    }
  }


  .client-chips {
    min-height: 48px;
    margin: 6px 0;
    padding: 0 16px 0 24px;

    .viewport-xs & {
      padding-left: 16px;
      padding-right: 8px;
    }

    .v-chip {
      opacity: 1;
    }
  }


  .client-card {

  }


  .client-actions {

  }


  // client photo
  .client-photo-col {
    .viewport-xs & {
      margin-bottom: 20px;
    }
  }

  .client-photo {
    position: relative;
    width: 100%;
    max-width: 410px;
    height: 100%;
    background-color: #fafafa;

    .viewport-xs & {
      max-width: none;
    }

    &:before {
      content: '';
      display: block;
      padding-bottom: 100%;

      .viewport-xl & {
        display: none;
      }
    }
  }


  .client-photo-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }


  .client-photo-add {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: opacity 0.2s ease;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }


  .client-photo-camera,
  .client-photo-cropper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    border-radius: 4px;
  }


  .client-photo-select {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    padding: 10px;
  }


  .client-photo-content {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translateY(-50%);

    > video {
      position: absolute;
      display: block;
      max-width: 100%;
      max-height: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    > img {
      position: absolute;
      display: block;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }


  .client-photo-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 4px;
  }


  .client-photo-actions {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    text-align: center;
  }


  // client info
  .client-info {

  }


  .client-info-group {

  }


  // vue tel input
  .v-input {
    .vue-tel-input {
      border: none;
      width: 100%;
      box-shadow: none !important;
      padding-left: 65px;

      .vti__dropdown {
        position: absolute;
        z-index: 3;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        border-radius: 3px;
        transition: background-color 0.2s ease;

        .vti__dropdown-list {
          background-color: #fff;
          padding: 0;
          box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
        }

        .vti__dropdown-item {
          padding: 6px 15px 6px 7px;
          color: #777;
        }
      }
    }
  }


  // tabs
  .ticket-tabs {


    .v-data-footer {
      background-color: #fff;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }


    .tab-placeholder {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      min-height: 100px;
      font-size: 16px;
      opacity: 0.5;
    }


    .ticket-card {
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;

      .card-toolbar {
        display: flex;
        flex-wrap: nowrap;
      }

      .v-card__title {
        font-size: 20px;
        line-height: 24px;
      }
    }
  }
</style>
